export default "__VITE_ASSET__V46XtK1c__"